import React from "react";
import { IconBaseProps } from "react-icons";

export const FlagSVG: React.FC<IconBaseProps> = ({ fill = "currentColor", size = 26 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 26 26"
    fill={fill}
    fillRule="evenodd"
    display="block"
  >
    <path d="M7 4h1.622v19H7zM9.838 15.26V5.007L21.614 10.2z"/>
  </svg>
);
